<template>
  <div class="bggray lc3-painel pt-5">
    <div class="container">
      <div class="row">
        <div class="col"></div>
        <div class="col-lg-5 col-md-7">
          <div class="row mb-4 mx-auto">
            <div class="col text-center"><img src="@/assets/logo.png" class="img-logo text-center"></div>
          </div>
          <h5 class="text-center">Backoffice administrativo</h5>
          <div class="p-3 mt-4 border rounded-3 cardlogin">
            <form @submit.prevent="login">
              <div class="mb-3">
                <label for="username" class="form-label">Usuário</label>
                <input class="form-control" required id="username" type="text" placeholder="Usuário ou e-mail" v-model="form.username">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Senha</label>
                <input class="form-control" id="password" required type="password" placeholder="Senha" v-model="form.password">
              </div>
              <div v-if="error" class="alert alert-danger py-2 small mb-3">{{ error }}</div>
              <button class="btn btn-primary w-100" type="submit" :disabled="loading">
                {{ loading ? 'Entrando...' : 'Entrar' }}
              </button>
            </form>
          </div>
        </div>
        <div class="col"></div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/services/http.js';
import { reactive, ref } from 'vue';
import { useAuth } from '@/services/auth.js';
import router from '@/router';

export default {
  name: 'LoginView',
  setup() {
    const auth = useAuth();
    const loading = ref(false);
    const error = ref('');

    const form = reactive({
      username: '',
      password: ''
    });

    const login = async () => {
      loading.value = true;
      error.value = '';
      try {
        const { data } = await http.post('/admin/login', form);
        auth.setToken(data.token);
        auth.setAdmin(data.admin);
        router.push({ name: 'dashboard' });
      } catch (err) {
        error.value = err?.response?.data?.errors?.username?.[0]
          ?? 'Usuário ou senha incorretos.';
      } finally {
        loading.value = false;
      }
    }

    return { form, login, loading, error }
  }
}
</script>

<style scoped>
  .lc3-painel {
    min-height: 100vh;
    max-height: 100vh;
  }

  .bggray {
    background-color: #e9e9e9;
  }

  .cardlogin {
    background-color: white;
  }

  .img-logo {
    width: 250px;
  }
</style>
